import { appUpgradeLoadingState, paymentModalOpenState, subscriptionOfferingsState, userDataState } from "@/lib/store";
import { useCallback, useRef } from "react";
import { useAtomValue, useSetAtom } from "jotai";

const useHandleAppUpgrade = () => {
    const offerings = useAtomValue(subscriptionOfferingsState);
    const offeringsRef = useRef<any>(null);
    offeringsRef.current = offerings;

    const userData = useAtomValue(userDataState);
    const setAppUpgradeLoading = useSetAtom(appUpgradeLoadingState);
    const setPaymentModalOpen = useSetAtom(paymentModalOpenState);

    const handleAppUpgrade = useCallback(
        async (selectedPackage?: any) => {
            const currentOfferings = offeringsRef.current;
            const packageToUse = selectedPackage ?? (Array.isArray(currentOfferings) ? currentOfferings[0] : null);
            try {
                setAppUpgradeLoading(true);
                // RevenueCat runs in the app shells only, so it is loaded on purchase, not with every web page.
                const { Purchases } = await import("@revenuecat/purchases-capacitor");
                await Purchases.purchasePackage({
                    aPackage: packageToUse,
                });
                await Purchases.setDisplayName({ displayName: userData?.first_name + " " + userData?.last_name });
                await Purchases.setEmail({ email: userData.email });
            } catch (error) {
                console.error("Purchase failed:", error);
            } finally {
                setAppUpgradeLoading(false);
                setPaymentModalOpen(false);
            }
        },
        [userData, setAppUpgradeLoading, setPaymentModalOpen]
    );

    return { handleAppUpgrade };
};

export default useHandleAppUpgrade;
